import liff from '@line/liff'

let initialized = false

/**
 * Initialize LIFF and ensure the user is logged in.
 * Returns the ID token (used as Bearer auth for our API).
 */
export async function initLiff(): Promise<string> {
  const liffId = import.meta.env.VITE_LIFF_ID
  if (!liffId) {
    throw new Error('VITE_LIFF_ID is not set. Configure it in apps/liff/.env')
  }

  if (!initialized) {
    await liff.init({ liffId })
    initialized = true
  }

  if (!liff.isLoggedIn()) {
    liff.login()
    // After login, the page reloads. Throw to halt the current render.
    throw new Error('Redirecting to LINE login...')
  }

  const idToken = liff.getIDToken()
  if (!idToken) throw new Error('Failed to obtain LIFF id_token')
  return idToken
}

export function getLiffProfile() {
  return liff.getProfile()
}

export function closeLiffWindow() {
  if (liff.isInClient()) liff.closeWindow()
}
